module.exports = __webpack_public_path__ + "static/flags/PK-1e2a857f95afdbeab5af38bd371b3c51.gif";